module.exports = __webpack_public_path__ + "img/ouvrages-colored.0dbc69cf.svg";